class ReadBarcode {
    constructor(){
        this.readBarcode = false;
        this.currentBarcode = "";
        this.savedBarcode = "";
        this.barcodeReady = false;
        this.CAPITAL_T = 84;
        this.STX_ETX = 2;
        this.DOT_CHAR = 190;
        this.START_CHAR_NUMBER = 32;
        this.END_CHAR_NUMBER = 126;
        this.CAPITAL_Z = 90;
        this.CARRIAGE_RETUN = 13;
    }

    getValue(){
        return this.savedBarcode;
    }

    isReady(){
        return this.barcodeReady;
    }

    listening(cb, timeInterval = 1000){
        //charCode 2 is for STX-ETX for Manhattan BarCode
        //charCode 84 is for wirless symcode, the T was prefixed to the barcode
        //The new barcode scanner doesn't have any prefix
        //Start Reading 
        if ((event.charCode === this.STX_ETX || event.charCode == this.CAPITAL_T || event.keyCode <= this.END_CHAR_NUMBER) && !this.readBarcode) {
            this.readBarcode = true;
            this.currentBarcode = "";
            this.barcodeReady = false;
            this.savedBarcode = "";

            //Returns the barcode after 1 second (1000 milliseconds) it started reading the code
            setTimeout(() => {
                this.readBarcode = false;
                this.savedBarcode = this.currentBarcode;
                this.barcodeReady = true;
                this.currentBarcode = "";
                if(this.savedBarcode.length >= 6) {
                    cb(this.savedBarcode);
                }
            }, timeInterval);
        }


        //Stop Reading
        if (event.keyCode !== this.DOT_CHAR && event.keyCode !== this.CAPITAL_Z && event.keyCode !== this.STX_ETX && event.keyCode !== this.CAPITAL_T && event.keyCode !== this.CARRIAGE_RETUN) {
            if (event.keyCode < this.START_CHAR_NUMBER || event.keyCode > this.END_CHAR_NUMBER) {
                this.readBarcode = false;
                this.currentBarcode = "";
                this.barcodeReady = false;
                this.savedBarcode = "";
            }
        }

        if (this.readBarcode) {
            if (event.keyCode >= this.START_CHAR_NUMBER && event.keyCode <= this.END_CHAR_NUMBER || event.keyCode === this.DOT_CHAR || event.keyCode === this.CAPITAL_Z ) {
                this.currentBarcode = this.currentBarcode.concat(event.key);
            }
        }

    }

}

export default ReadBarcode;
